var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 5.73047H9.375C8.22917 5.73047 7.29167 6.66797 7.29167 7.8138V17.1888C7.29167 17.7413 7.51116 18.2712 7.90186 18.6619C8.29256 19.0526 8.82246 19.2721 9.375 19.2721H22.9167C24.0729 19.2721 25 18.3451 25 17.1888V7.8138C25 7.26127 24.7805 6.73136 24.3898 6.34066C23.9991 5.94996 23.4692 5.73047 22.9167 5.73047ZM22.9167 17.1888H9.375V9.55339L16.1458 13.0221L22.9167 9.55339V17.1888ZM16.1458 11.2617L9.375 7.8138H22.9167L16.1458 11.2617ZM5.20833 17.1888C5.20833 17.3659 5.23958 17.5326 5.26042 17.7096H1.04167C0.466667 17.7096 0 17.2409 0 16.668C0 16.0951 0.466667 15.6263 1.04167 15.6263H5.20833V17.1888ZM3.125 7.29297H5.26042C5.23958 7.47005 5.20833 7.63672 5.20833 7.8138V9.3763H3.125C2.55208 9.3763 2.08333 8.90755 2.08333 8.33464C2.08333 7.76172 2.55208 7.29297 3.125 7.29297ZM1.04167 12.5013C1.04167 11.9284 1.51042 11.4596 2.08333 11.4596H5.20833V13.543H2.08333C1.51042 13.543 1.04167 13.0742 1.04167 12.5013Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/invitation.95392ddfccbf87d866f02ea857056916.svg";
export { ForwardRef as ReactComponent };